import React, { useEffect, useState } from 'react'
import { connect } from 'dva'
import PropTypes from 'prop-types'

import { BASEMAPS, CONTAINER_IDS, MAP_MODES, MAP_VIEW_PROPS, SIDEBAR_VIEWS } from '../../lib/constants'
import actions from './actions'
import ClickPopupHandler from './ClickPopupHandler'
import EditFeature from './EditFeature'
import GraphicsLayer from './GraphicsLayer'
import MapInitializer from './MapInitializer'
import styles from './MapView.module.scss'
import ZoomLevel from './ZoomLevel'

function MapView(props) {
  const [isCursorTooltipViewable, setIsCursorTooltipViewable] = useState(false)
  const [cursorTooltipPosition, setCursorTooltipPosition] = useState(null)
  const [cursorTooltipTimeoutId, setCursorTooltipTimeoutId] = useState(null)

  useEffect(() => {
    if (props.mapHasLoaded) {
      props.completeMapChange(props.featuresCount, props.visible, props.hasSidebarView)
    }
  }, [props.mapHasLoaded])

  const mapProps = {
    ground: 'world-elevation',
    basemap:{
      baseLayers: []
    },
    layers: []
  }
  const viewProps = {
    background: {
      color: MAP_VIEW_PROPS.background.color
    },
    container: CONTAINER_IDS.map,
    center: [-99.64, 39.26],
    zoom: 5,
    padding: {
      left: 72
    },
    ui: {
      components: ['attribution'] // empty's the UI, except for attribution
    }
  }
  
  let mouseEventHandlers = {}
  if (props.isHistoricalView && !props.isTopographicBasemap) {
    const handleMouseClick = () => {
      setIsCursorTooltipViewable(false)
      setCursorTooltipPosition(null)
      if (cursorTooltipTimeoutId) {
        clearTimeout(cursorTooltipTimeoutId)
      }
    }
    const handleMouseLeave = () => {
      setIsCursorTooltipViewable(false)
      setCursorTooltipPosition(null)
      if (cursorTooltipTimeoutId) {
        clearTimeout(cursorTooltipTimeoutId)
      }
    }
    const handleMouseMove = e => {
      if (isCursorTooltipViewable) {
        setIsCursorTooltipViewable(false)
      }
      if (cursorTooltipTimeoutId) {
        clearTimeout(cursorTooltipTimeoutId)
      }
      setCursorTooltipPosition({ left: e.pageX - 68, top: e.pageY + 20 })
      const timeoutId = setTimeout(() => {
        setIsCursorTooltipViewable(true)
      }, 1000)
      setCursorTooltipTimeoutId(timeoutId)
    }
    mouseEventHandlers = {
      onClick: handleMouseClick,
      onMouseLeave: handleMouseLeave,
      onMouseMove: handleMouseMove
    }
  } else {
    mouseEventHandlers = {}
  }

  return (
    <div className={styles.mapContainer}>
      <div id={CONTAINER_IDS.map} className={styles.ghMap} {...mouseEventHandlers}>
        <MapInitializer mapProps={mapProps} viewProps={viewProps} />
        {props.mapRef && (
          <>
            {props.isHistoricalView && isCursorTooltipViewable && (
              <div className={styles.cursorToolTip} style={cursorTooltipPosition}>
                Click for imagery date
              </div>
            )}
            <ClickPopupHandler map={props.mapRef} view={props.viewRef} />
            <EditFeature map={props.mapRef} view={props.viewRef} />
            <GraphicsLayer map={props.mapRef} view={props.viewRef} />
            <ZoomLevel map={props.mapRef} view={props.viewRef} showZoomLevel={props.showZoomLevel} />
          </>
        )}
      </div>
    </div>
  )
}

MapView.propTypes = {
  basemapMode: PropTypes.string,
  basemaps: PropTypes.array,
  contentConfig: PropTypes.object,
  featuresCount: PropTypes.number,
  hasSidebarView: PropTypes.bool,
  isHistoricalView: PropTypes.bool,
  isTopographicBasemap: PropTypes.bool,
  layers: PropTypes.array,
  mapHasLoaded: PropTypes.bool,
  mapRef: PropTypes.any,
  showSidebar: PropTypes.bool,
  showZoomLevel: PropTypes.bool,
  viewRef: PropTypes.any,
  visible: PropTypes.object,
  // actions
  completeMapChange: PropTypes.func
}

export default connect(model => {
  const { basemapMode, basemaps, isChangingMapMode, isMapLoading, mapMode, mapRef, mapViewRef, sceneViewRef, showSidebar } = model.map
  const { config, sidebarView } = model.app
  const { layersByEvent, layersByState } = model.layers
  const contentConfig = config.CONTENT_LAYERS

  const hasSidebarView = Boolean(sidebarView.view)
  const isHistoricalView = sidebarView.view === SIDEBAR_VIEWS.HistoricalImagery
  const isTopographicBasemap = basemapMode === BASEMAPS.Topographic
  const layers = [...layersByEvent, ...layersByState]
  const showZoomLevel = config.REACT_APP_FIREBASE_PROJECT_ID == 'gohunt-staging'
  const viewRef = mapMode === MAP_MODES.TwoD ? mapViewRef : sceneViewRef
  let featuresCount = 0
  let mapHasLoaded = false
  let visible = {}
  if (mapRef) {
    const { loaded, loadStatus } = mapRef.ground
    const mapLoadIsComplete = loaded === true && loadStatus === 'loaded'
    mapHasLoaded = isChangingMapMode && !isMapLoading && mapLoadIsComplete
    if (mapHasLoaded) {
      const { featuresList, preferences } = model.features
      featuresCount = featuresList.length
      visible = preferences.visible
    }
  }


  return {
    basemapMode,
    basemaps,
    contentConfig,
    featuresCount,
    hasSidebarView,
    isHistoricalView,
    isTopographicBasemap,
    layers,
    mapHasLoaded,
    mapRef,
    showSidebar,
    showZoomLevel,
    viewRef,
    visible
  }
}, actions)(MapView)
